import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ApiMbaasService } from 'src/app/services/api-mbaas.service';
import { ApiResource } from 'src/app/resources/api.resource';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-daviviendamovil',
  templateUrl: './mbaas.component.html',
  styleUrls: ['./mbaas.component.scss']
})
export class MbaasComponent implements OnInit {

  public CodMessage = null;
  public safeUrl = null;
  public mbaasURL = null;
  public cargando = true;
  public HeaderHtml = null;
  public FooterHtml = null;
  public menuHeaderHtml = null;
  public menuFooterHtml = null;
  public BotonesDeSlides = null;
  public sliderHtml = null;
  public tabsHtml = null;
  public responseUuid = null;
  public productsHtml = null;
  public customHtml = null;
  public habilitarPaginaBuscar = false;
  public mostrarActivos = false;
  public configuration = null;
  public formulario = null;
  public mapa = {};
  public departamentosEnCasoDeQueVengaVacioElNodo = [];
  public descargarDocumentos = false;
  public timeLeft: number = 10;
  public interval;
  public eventMessage = null;
  public urlDestinoNavegacion = null;
  public temporizadorRedireccion;
  public contadorTiempo = null;
  public esRegresar = null;

  constructor(private resource: ApiResource,private rutaActiva: ActivatedRoute, 
    private sanitizer: DomSanitizer,private pdServiceMbaas: ApiMbaasService,
    private http: HttpClient, private route: Router) {

      //this.readyFuctionPrueba = this.readyFuctionPrueba.bind(this);

    }

  ngOnInit() {
    var cssMbaaSH = window.document.getElementById('htmlEdit');
    cssMbaaSH.style.overflowY="-webkit-paged-y !important";
  var cssMbaaS = document.getElementById("mbaasBody");
  cssMbaaS.style.marginBottom="0%";

    if (this.rutaActiva.snapshot.params.uuid) {
      if (this.rutaActiva.snapshot.params.uuid == 'activos') {
        this.obtenerPaginaActivos("portal_principal_personas");
      }
      else if (this.rutaActiva.snapshot.params.uuid == 'documentos') {
        console.log(this.rutaActiva.snapshot.params.uuid);
        this.obtenerPagina("portal_principal_personas");
        this.descargarDocumentos = true;
      }
      else {
        this.obtenerPagina(this.rutaActiva.snapshot.params.uuid);
        this.mostrarActivos = false;
      }
    }
    else {
      this.obtenerPagina("portal_principal_personas");
      this.mostrarActivos = false;
    }
    //==========================================
    // INICIO INTEGRACION MBASS 'https://mbaas.lab.cam.davivienda.com'  window.location.href window.top.document.getElementById 'https://mbaas.lab.cam.davivienda.com'
    //==========================================
  
    this.obtenerUrlMbaas();
    function receivedMessage(event){

      //if(event.origin == 'https://mbaas.lab.cam.davivienda.com'){
      if(event.origin == 'https://mbaas.cam.davivienda.com'){

        this.eventMessage = event.data.event;
        if(this.eventMessage == 'navigate'){
          /* 
          * Hugo Dimas - Fatima Mejia - Proceso de Redireccion de TC Digital
          * SECCION DE POSTMESSAGES DE REDIRECCION TC DIGITAL
          */
         $( "#btnRegresarTC" ).hide();
          var tipoNavegacion = event.data.message.direction;
          this.urlDestinoNavegacion = String(event.data.message.redirectUrl);
          $('#destinationRedirectTC').text(this.urlDestinoNavegacion);
          //this.urlDestinoNavegacion = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlDestinoNavegacion);
          
          //LEVANTAR MODAL
          console.warn('CLASE ACTIVA: ' + $('.page-modal .modal').hasClass('modal'));
          let modalForm = $('#modalRedireccionamiento');
          $('body').addClass('overflow-hidden');

          modalForm.toggleClass('active');
          $('.page-modal .modal').removeClass('active');
          $('.page-modal .modal-5').addClass('active');
          
          //FUNCION TIMER
          this.contadorTiempo = 10;
          this.temporizadorRedireccion = setInterval(function(){

            this.esRegresar = false;
            $('#timerRedirectTC').text(this.contadorTiempo);
            
            let modalForm = $('#modalRedireccionamiento');
            $('body').removeClass('overflow-hidden');
            
            if(this.contadorTiempo == 1 && !this.esRegresar ){
              console.warn("CONTINUE: " + this.contadorTiempo);
              clearInterval(this.temporizadorRedireccion);
              window.open(this.urlDestinoNavegacion, "_blank");

              $( "#btnRegresarTC" ).show();
              
            }
            this.contadorTiempo--;

          }, 1000);

        }else{
          //SECCION DE POSTMESSAGES INICIALES CUENTA Y CREDITO MOVIL
          this.CodMessage = event.data.statusMessage;
          //console.warn("status: " + event.data.status);
          //console.warn("statusCode: " + event.data.statusCode);
          console.warn("statusMessage: " + event.data.statusMessage);
      
          if(this.CodMessage == "op_home"){
            window.location.href = 'https://www.davivienda.com.sv/#/personas';
          }
          if(this.CodMessage == "op_recuperarclave"){
            window.location.href = 'https://bancaelectronica.davivienda.com.sv/PersonalBanking/login.davivienda';
          }
          if(this.CodMessage == "op_asignarclave"){
            window.location.href = 'https://bancaelectronica.davivienda.com.sv/PersonalBanking/login.davivienda';
          }
          if(this.CodMessage == "op_actualizaciondatos"){
            window.location.href = 'https://bancaelectronica.davivienda.com.sv/PersonalBanking/login.davivienda';
          }
          if(this.CodMessage == "op_login"){
            window.location.href = 'https://bancaelectronica.davivienda.com.sv/PersonalBanking/login.davivienda';
          }
        }
      }
    }

    window.addEventListener("message",receivedMessage,false);

    //==========================================
    // FIN INTEGRACION MBASS
    //==========================================
}

/* 
* Hugo Dimas - Fatima Mejia - Proceso de Redireccion de TC Digital
*/

public cerrarModalRedireccionamiento() {
  console.warn('Iniciando cierre modal...');
  let modalForm = $('#modalRedireccionamiento');
  if (modalForm.hasClass('active')) {
    $('body').removeClass('overflow-hidden');
  } else {
    $('body').addClass('overflow-hidden');
  }

  modalForm.toggleClass('active');
  $('.page-modal .modal').removeClass('active');
  $('.page-modal .modal-5').removeClass('active');
  
}

//==========================================
// INICIO INTEGRACION MBASS
//==========================================

//generador de SessionId
  public generateSessionId(){
    var d  = new Date().getTime();
    var uuid = 'x1xxxyxx'.replace(/[xy]/g, function (c){
      var r = (d + Math.random() * 16 ) % 16 | 0;
      d = Math.floor(d/16);
      return (c == 'X' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    var sessionId = "ses-"+uuid;
    return sessionId;
  }
  //generador de transactionId
  public generatetransactionId(){
    var d  = new Date().getTime();
    var uuid = 'xxyxxxx'.replace(/[xy]/g, function (c){
      var r = (d + Math.random() * 16 ) % 16 | 0;
      d = Math.floor(d/16);
      return (c == 'X' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    var transactionId = "t"+uuid;
    return transactionId;
  }
  //payload
  public respuestaJsonMbaas: any = {
      codCanal:"01", 
      payloadPresentacion:{
      client:{
        documentClient:{
          number: "",
          type: "01"
        }
        },
        partner:{  
          id:"LM",
          callbackUrl:{  
              error:"https://www.davivienda.com.sv/#/personas",
              success:"https://bancaelectronica.davivienda.com.sv/PersonalBanking/login.davivienda"
          }
      },
      module:{
        country:"SV",
        id:"MNUING"
      },
      consumer:{
        appConsumer:{
            id:"APPTRN_MOVIL_SV",
            sessionId:this.generateSessionId(),
            transactionId:this.generatetransactionId(),
            canalId:"1",
            terminalId:"1"
        },
        deviceConsumer:{
            id:"device-11111122222",
            userAgent: navigator.userAgent,
            locale: "SV",
            sessionTimeout:"600000",
            inactiveInterval:"600000"
        }
      }
    }
  };
  public obtenerUrlMbaas() {
      this.toggleModal(false);
      try {
        const idioma = (localStorage.getItem('idiomaEspañol') === 'true') ? 'EN' : 'ES';
        const url = `${environment.mbaasApiUrl}/api/v1/mbaas/presentacion`;

        this.http.post<any>(url, { idioma }).subscribe(resp => {

          // El controlador Java devuelve directamente el objeto "data" de la
          // respuesta de MBaaS en caso de éxito, o {success:false, error:"..."}
          // si algo falló (NoSuchFileException, 403 Incapsula, etc.).
          if (resp && resp.success === false) {
            console.error('Error MBaaS: ', resp.error);
            this.cargando = false;
            this.toggleModal(true);
            return;
          }

          // Se busca la URL de presentación dentro de la respuesta,
          // soportando distintos posibles nombres de campo. El backend
          // MBaaS responde con "appUrl" (junto a "otp" y "clientId").
          const urlPresentacion = (resp && (resp.appUrl || resp.url || resp.redirectUrl || resp.link
            || resp.urlPresentacion)) || (typeof resp === 'string' ? resp : null);

          if (!urlPresentacion) {
            console.error('Respuesta MBaaS sin URL reconocible: ', resp);
            this.cargando = false;
            this.toggleModal(true);
            return;
          }

          this.cargando = false;
          this.mbaasURL = urlPresentacion;
          this.iframeURL();
          $('#modalError').hide();

        }, err => {
          console.error('Error al invocar el servicio MBaaS: ', err);
          this.cargando = false;
          this.toggleModal(true);
        });
      } catch (error) {
        this.cargando = false;
        this.toggleModal(true);
      }
  }
  toggleModal(isLast = false) {
    let modalForm = $('#modalError');
    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }
    if(isLast){
      modalForm.toggleClass('active');
      $('.page-modal .modal').removeClass('active');
      $('.page-modal .modal-4').addClass('active')
    }
  }
  toggleModalRedirect(isLast = false) {
    let modalForm = $('#modalRedireccionamiento');
    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }
    if(isLast){
      modalForm.toggleClass('active');
      $('.page-modal .modal').removeClass('active');
      $('.page-modal .modal-4').addClass('active');
    }
  }
  public cerrarModal() {
    //clearInterval(this.interval);
    this.route.navigateByUrl("personas");
  }
  public iframeURL() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.mbaasURL);
  }

  //==========================================
  // FIN INTEGRACION MBASS
  //==========================================

  public obtenerPagina(uuid): any {


    if (uuid === 'mbaas') {
      // Ya estamos en el componente de MBaaS, solo se recarga la presentación.
      this.obtenerUrlMbaas();
      return;
    }

    if (uuid == "activos") {
      this.obtenerPaginaActivos("portal_principal_personas");
    }
    else if (uuid == "documentos") {
      // console.log(uuid);
      this.descargarDocumentos = true;


      let modalForm = $('#documentos');

      if (modalForm.hasClass('active')) {
        $('body').removeClass('overflow-hidden');
      } else {
        $('body').addClass('overflow-hidden');
      }

      modalForm.toggleClass('active');

    }
    else {
      
      this.mostrarActivos = false;
      this.habilitarPaginaBuscar = true;
      this.sliderHtml = null;
      this.BotonesDeSlides = null;
      this.tabsHtml = null;
      this.responseUuid = null;
      this.productsHtml = null;
      this.customHtml = null;
      this.sliderHtml = null;

      this.habilitarPaginaBuscar = false;
      this.resource.obtenerHtmlPorUUID(uuid).subscribe(
        (resp) => {
          // console.warn("resp", resp);
          this.responseUuid = resp;

          for (let web of resp.elementos_web) {
            if (web.posicion == 'Pre-Header') {
              this.HeaderHtml = web;
            }
            else if (web.posicion == 'Footer') {
              this.FooterHtml = web;
            }
          }

          //verificar si viene formulario
          if (resp.details.formulario) {
            this.formulario = resp.details.formulario;
          }
          else {
            this.formulario = null;
          }

          this.menuFooterHtml = resp.elementos_footer;
          this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);


          // la pagina es de tipo custom
          if (resp.details.tabs == null && resp.details.products == null && resp.details.slides == null) {
            this.customHtml = resp.details;
            console.warn("custom");
          }
          else {
            this.customHtml = null;
          }

          //la pagina es de tipo tabs
          if (resp.details.tabs != null) {
            this.tabsHtml = resp.details;
          }
          else {
            this.tabsHtml = null;
          }


          //la pagina es de tipo producs
          if (resp.details.products != null) {
            this.productsHtml = resp.details;
          }
          else {
            this.productsHtml = null;
          }

          this.configuration = resp.configuration;

          localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

          this.initFullpage();
          $(".c-body").removeClass("overflow-hidden");
        }
      );
    }
  }
  public obtenerPaginaActivos(uuid): any {
    this.habilitarPaginaBuscar = true;
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;
    this.sliderHtml = null;

    this.habilitarPaginaBuscar = false;

    this.resource.obtenerHtmlPorUUID(uuid).subscribe(
      (resp) => {
        this.responseUuid = resp;

        for (let web of resp.elementos_web) {
          if (web.posicion == 'Pre-Header') {
            this.HeaderHtml = web;
          }
          else if (web.posicion == 'Footer') {
            this.FooterHtml = web;
          }
        }



        //enviado de datos del correo
        this.configuration = resp.configuration;
        localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

        //this.configurationEmit.emit(this.configuration);
        // console.warn(" this.configuration",  this.configuration);

        this.menuFooterHtml = resp.elementos_footer;
        this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);
        this.customHtml = null;
        // la pagina es de tipo slides 
        this.BotonesDeSlides = null;
        this.sliderHtml = null;
        //la pagina es de tipo producs      
        this.productsHtml = null;

        this.mostrarActivos = true;

        this.initFullpage();
        $(".c-body").removeClass("overflow-hidden");
      }
    );
  }
  private initFullpage() {
    const $el = document.querySelector('#test-c');

    if ($el) {
      const html = `
            <script>

              if (!window.startIntro) {
                window.startIntro = true;
              }
              setTimeout(function () {
                if ($.fn.fullpage.destroy) {
                  $.fn.fullpage.destroy('all');
                  // console.warn("$.fn.fullpage.destroy");
                }

                setTimeout(function () {
                  $('#fullpage').fullpage({
                    // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                    menu: '#myMenu',
                    scrollingSpeed: 1000,
                    autoScrolling: true,
                    scrollOverflow: false,
                    resize: false,
                    
                    keyboardScrolling: false,
                    afterRender: function () {
                      var $map = document.getElementById('inner-map');
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-1');

                      $items.removeClass('custom-class-active');
                      $next.addClass('example custom-class-active');
                    },
                    onLeave: function(index, nextIndex, direction) {
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-'+nextIndex);

                      $items.removeClass('custom-class-active');
                      $next.addClass('custom-class-active');
                    }
                  });
                }, 100);
              }, 75);
            </script>
      `;

      const fragment = document.createRange().createContextualFragment(html);
      $el.appendChild(fragment);
    }
  }
  private crearRowParaContenidoDeMenu(array) {
    let i, j, tempArray = [], chunk = 4;
    let innerArray = [];
    for (i = 0, j = array.length; i < j; i++) {
      if (array[i].html_icon !== '-' && array[i].descripcion !== ' ' && array[i].descripcion !== '') {
        innerArray.push(array[i]);
      }
    }
    for (i = 0, j = innerArray.length; i < j; i += chunk) {
      tempArray.push(innerArray.slice(i, i + chunk));
    }
    return tempArray;
  }
  public buscar(buscar) {
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.sliderHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;

    this.habilitarPaginaBuscar = true;
  }

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
  }

  // public obtenerLocations(data) {
  //   this.resource.obtenerLocations(data).subscribe(resp => {
  //     //para que queden guardado los departamentos y no se reseten del select
  //     if (resp.filters) {
  //       this.departamentosEnCasoDeQueVengaVacioElNodo = resp.filters;
  //     }
  //     else {
  //       resp.filters = this.departamentosEnCasoDeQueVengaVacioElNodo;
  //     }
  //     this.mapa = resp;
  //   }, err => {
  //     this.mapa = null;
  //   });
  // }
}

